import { render, staticRenderFns } from "./escposPrinter.vue?vue&type=template&id=60556c0f&scoped=true&"
import script from "./escposPrinter.vue?vue&type=script&lang=js&"
export * from "./escposPrinter.vue?vue&type=script&lang=js&"
import style0 from "./escposPrinter.vue?vue&type=style&index=0&id=60556c0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60556c0f",
  null
  
)

export default component.exports